import { render, staticRenderFns } from "./LdDismissableBanner.vue?vue&type=template&id=1ab1522f"
import script from "./LdDismissableBanner.vue?vue&type=script&lang=js"
export * from "./LdDismissableBanner.vue?vue&type=script&lang=js"
import style0 from "./LdDismissableBanner.vue?vue&type=style&index=0&id=1ab1522f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports